/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiCustomerAllGet$Json } from '../fn/customer/api-customer-all-get-json';
import { ApiCustomerAllGet$Json$Params } from '../fn/customer/api-customer-all-get-json';
import { apiCustomerAllGet$Plain } from '../fn/customer/api-customer-all-get-plain';
import { ApiCustomerAllGet$Plain$Params } from '../fn/customer/api-customer-all-get-plain';
import { apiCustomerCustomerIdCollectedServiceDateGet$Json } from '../fn/customer/api-customer-customer-id-collected-service-date-get-json';
import { ApiCustomerCustomerIdCollectedServiceDateGet$Json$Params } from '../fn/customer/api-customer-customer-id-collected-service-date-get-json';
import { apiCustomerCustomerIdCollectedServiceDateGet$Plain } from '../fn/customer/api-customer-customer-id-collected-service-date-get-plain';
import { ApiCustomerCustomerIdCollectedServiceDateGet$Plain$Params } from '../fn/customer/api-customer-customer-id-collected-service-date-get-plain';
import { apiCustomerDetailsCustomerIdGet$Json } from '../fn/customer/api-customer-details-customer-id-get-json';
import { ApiCustomerDetailsCustomerIdGet$Json$Params } from '../fn/customer/api-customer-details-customer-id-get-json';
import { apiCustomerDetailsCustomerIdGet$Plain } from '../fn/customer/api-customer-details-customer-id-get-plain';
import { ApiCustomerDetailsCustomerIdGet$Plain$Params } from '../fn/customer/api-customer-details-customer-id-get-plain';
import { apiCustomerGet$Json } from '../fn/customer/api-customer-get-json';
import { ApiCustomerGet$Json$Params } from '../fn/customer/api-customer-get-json';
import { apiCustomerGet$Plain } from '../fn/customer/api-customer-get-plain';
import { ApiCustomerGet$Plain$Params } from '../fn/customer/api-customer-get-plain';
import { CustomerDto } from '../models/customer-dto';

@Injectable({ providedIn: 'root' })
export class CustomerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiCustomerGet()` */
  static readonly ApiCustomerGetPath = '/api/Customer';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerGet$Plain$Response(params?: ApiCustomerGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CustomerDto>>> {
    return apiCustomerGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCustomerGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerGet$Plain(params?: ApiCustomerGet$Plain$Params, context?: HttpContext): Observable<Array<CustomerDto>> {
    return this.apiCustomerGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CustomerDto>>): Array<CustomerDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerGet$Json$Response(params?: ApiCustomerGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CustomerDto>>> {
    return apiCustomerGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCustomerGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerGet$Json(params?: ApiCustomerGet$Json$Params, context?: HttpContext): Observable<Array<CustomerDto>> {
    return this.apiCustomerGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CustomerDto>>): Array<CustomerDto> => r.body)
    );
  }

  /** Path part for operation `apiCustomerAllGet()` */
  static readonly ApiCustomerAllGetPath = '/api/Customer/all';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerAllGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerAllGet$Plain$Response(params?: ApiCustomerAllGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CustomerDto>>> {
    return apiCustomerAllGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCustomerAllGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerAllGet$Plain(params?: ApiCustomerAllGet$Plain$Params, context?: HttpContext): Observable<Array<CustomerDto>> {
    return this.apiCustomerAllGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CustomerDto>>): Array<CustomerDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerAllGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerAllGet$Json$Response(params?: ApiCustomerAllGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CustomerDto>>> {
    return apiCustomerAllGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCustomerAllGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerAllGet$Json(params?: ApiCustomerAllGet$Json$Params, context?: HttpContext): Observable<Array<CustomerDto>> {
    return this.apiCustomerAllGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CustomerDto>>): Array<CustomerDto> => r.body)
    );
  }

  /** Path part for operation `apiCustomerDetailsCustomerIdGet()` */
  static readonly ApiCustomerDetailsCustomerIdGetPath = '/api/Customer/details/{customerId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerDetailsCustomerIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerDetailsCustomerIdGet$Plain$Response(params: ApiCustomerDetailsCustomerIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerDto>> {
    return apiCustomerDetailsCustomerIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCustomerDetailsCustomerIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerDetailsCustomerIdGet$Plain(params: ApiCustomerDetailsCustomerIdGet$Plain$Params, context?: HttpContext): Observable<CustomerDto> {
    return this.apiCustomerDetailsCustomerIdGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerDto>): CustomerDto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerDetailsCustomerIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerDetailsCustomerIdGet$Json$Response(params: ApiCustomerDetailsCustomerIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerDto>> {
    return apiCustomerDetailsCustomerIdGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCustomerDetailsCustomerIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerDetailsCustomerIdGet$Json(params: ApiCustomerDetailsCustomerIdGet$Json$Params, context?: HttpContext): Observable<CustomerDto> {
    return this.apiCustomerDetailsCustomerIdGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerDto>): CustomerDto => r.body)
    );
  }

  /** Path part for operation `apiCustomerCustomerIdCollectedServiceDateGet()` */
  static readonly ApiCustomerCustomerIdCollectedServiceDateGetPath = '/api/Customer/{customerId}/{collectedServiceDate}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerCustomerIdCollectedServiceDateGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerCustomerIdCollectedServiceDateGet$Plain$Response(params: ApiCustomerCustomerIdCollectedServiceDateGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerDto>> {
    return apiCustomerCustomerIdCollectedServiceDateGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCustomerCustomerIdCollectedServiceDateGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerCustomerIdCollectedServiceDateGet$Plain(params: ApiCustomerCustomerIdCollectedServiceDateGet$Plain$Params, context?: HttpContext): Observable<CustomerDto> {
    return this.apiCustomerCustomerIdCollectedServiceDateGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerDto>): CustomerDto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCustomerCustomerIdCollectedServiceDateGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerCustomerIdCollectedServiceDateGet$Json$Response(params: ApiCustomerCustomerIdCollectedServiceDateGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerDto>> {
    return apiCustomerCustomerIdCollectedServiceDateGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCustomerCustomerIdCollectedServiceDateGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCustomerCustomerIdCollectedServiceDateGet$Json(params: ApiCustomerCustomerIdCollectedServiceDateGet$Json$Params, context?: HttpContext): Observable<CustomerDto> {
    return this.apiCustomerCustomerIdCollectedServiceDateGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomerDto>): CustomerDto => r.body)
    );
  }

}
